import { useState } from "react";
import { LEAGUE } from "../../config/league";

/**
 * Hero banner for the main page (the show's YouTube-thumbnail art). The whole
 * banner links to the YouTube video when LEAGUE.streamUrl is set. Hides itself
 * gracefully if the image is missing. Drop the art at public/hero.jpg.
 */
const FALLBACK = "/hero.svg";

export function HeroBanner() {
  const [src, setSrc] = useState<string>(LEAGUE.heroImage);
  const [failed, setFailed] = useState(false);
  if (failed) return null;

  const inner = (
    <>
      <img
        src={src}
        alt={`${LEAGUE.brandName} — ${LEAGUE.seasonName}`}
        className="block w-full"
        onError={() => (src === FALLBACK ? setFailed(true) : setSrc(FALLBACK))}
      />
      {/* Blend the bottom edge into the dark page. */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-ink-950 to-transparent" />
      {LEAGUE.streamUrl && (
        <span className="absolute right-4 top-4 inline-flex items-center gap-2 rounded-full bg-loss px-4 py-2 text-sm font-bold text-white shadow-lg backdrop-blur transition group-hover:brightness-110">
          <span className="h-2 w-2 animate-pulseclock rounded-full bg-white" />
          Watch the Draft
        </span>
      )}
    </>
  );

  const base =
    "group relative block overflow-hidden rounded-2xl border border-edge shadow-glow";

  if (LEAGUE.streamUrl) {
    return (
      <a
        href={LEAGUE.streamUrl}
        target="_blank"
        rel="noreferrer"
        aria-label={`Watch ${LEAGUE.brandName} on YouTube`}
        className={`${base} cursor-pointer transition hover:border-accent/60`}
      >
        {inner}
      </a>
    );
  }
  return <div className={base}>{inner}</div>;
}
